import { ConvexBetterAuthProvider } from '@convex-dev/better-auth/react'
import { ConvexQueryClient } from '@convex-dev/react-query'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { ConvexReactClient } from 'convex/react'
import { HelmetProvider } from 'react-helmet-async'
import { env } from '@/env.client'
import { authClient } from '@/lib/auth-client'
import { router } from '@/router'
import { PostHogProvider } from '@/shared/providers/posthog-provider'
import '@/i18n'

const convex = new ConvexReactClient(env.VITE_CONVEX_URL)

const convexQueryClient = new ConvexQueryClient(convex)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryKeyHashFn: convexQueryClient.hashFn(),
      queryFn: convexQueryClient.queryFn(),
    },
  },
})

convexQueryClient.connect(queryClient)

function InnerApp() {
  return <RouterProvider router={router} context={{ queryClient }} />
}

const helmetContext = {}

export default function App() {
  return (
    <HelmetProvider context={helmetContext}>
      <PostHogProvider>
        <ConvexBetterAuthProvider client={convex} authClient={authClient}>
          <QueryClientProvider client={queryClient}>
            <InnerApp />
          </QueryClientProvider>
        </ConvexBetterAuthProvider>
      </PostHogProvider>
    </HelmetProvider>
  )
}
